import type { Chat } from '@liniya/api-client';
import { ArrowLeft, PanelRightClose, Phone, Video } from 'lucide-react';

import { Avatar } from '@/components/Avatar';
import { ChatMenu } from './ChatMenu';
import { usePresenceStore } from '@liniya/client-core';
import { useUiStore } from '@liniya/client-core';

interface Props {
  chat: Chat;
  onBack: () => void;
  onStartCall: (kind: 'audio' | 'video') => void;
  onOpenDetails: () => void;
}

export function ChatHeader({ chat, onBack, onStartCall, onOpenDetails }: Props) {
  const toggleDetails = useUiStore((state) => state.toggleDetails);
  const detailsOpen = useUiStore((state) => state.detailsOpen);
  const online = usePresenceStore((state) =>
    chat.peer_user_id ? (state.onlineUserIds[chat.peer_user_id] ?? chat.peer_is_online) : false,
  );
  const typing = usePresenceStore((state) => state.typingByChat[chat.id]?.length ?? 0);

  const status =
    typing > 0
      ? 'печатает…'
      : chat.kind === 'direct'
        ? online
          ? 'В сети'
          : chat.presence_label
        : chat.presence_label;

  return (
    <header className="topbar chat-head">
      <button className="icon-btn" type="button" aria-label="Назад к списку чатов" onClick={onBack}>
        <ArrowLeft size={20} />
      </button>
      <Avatar name={chat.title} kind={chat.kind} />
      <div className="contact">
        <strong>{chat.title}</strong>
        <small className={online && chat.kind === 'direct' ? 'peer-presence is-online' : 'peer-presence'}>
          {status}
        </small>
      </div>

      <button
        className="icon-btn details-toggle"
        type="button"
        aria-label={detailsOpen ? 'Скрыть информацию о чате' : 'Показать информацию о чате'}
        aria-pressed={detailsOpen}
        onClick={toggleDetails}
      >
        <PanelRightClose size={19} />
      </button>

      <div className="chat-actions">
        {chat.kind === 'direct' && chat.peer_user_id ? (
          <>
            <button
              className="icon-btn"
              type="button"
              aria-label="Аудиозвонок"
              onClick={() => onStartCall('audio')}
            >
              <Phone size={19} />
            </button>
            <button
              className="icon-btn"
              type="button"
              aria-label="Видеозвонок"
              onClick={() => onStartCall('video')}
            >
              <Video size={19} />
            </button>
          </>
        ) : null}
        <ChatMenu chat={chat} onOpenDetails={onOpenDetails} />
      </div>
    </header>
  );
}
